module.exports = __webpack_public_path__ + "static/img/hitbox.17a8a967.png";